import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const CancelTfMail = () => {
  const { chatData, refreshChatData, validateEcode } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelTransfer = async (e) => {
    e.preventDefault();

    if (!window.confirm("Are you sure you want to cancel the transfer?"))
      return;

    setIsLoading(true);

    try {
      const response = await fetch(
        "https://kracet.shop/mastapi/cancelmailtf.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatData?.chat_id,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Transfer cancelled successfully!");
        refreshChatData();
        validateEcode();
      } else {
        alert("Cancel failed: " + result.message);
      }
    } catch (error) {
      console.error("Error cancelling transfer:", error);
      alert("An error occurred while cancelling the transfer.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleCancelTransfer} className="mt-7">
      <button
        type="submit"
        className="text-sm text-blue-600 font-semibold flex items-center"
        disabled={isLoading}
      >
        {isLoading && (
          <svg
            className="animate-spin h-4 w-4 mr-2 text-blue-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8z"
            ></path>
          </svg>
        )}
        {isLoading ? "Cancelling..." : "Cancel Transfer"}
      </button>
    </form>
  );
};

export default CancelTfMail;
